The tax code of the product price.
